import { ChatMessageHistoryDataAction } from '../../Actions/ChatHistory';
import { MessageAction } from '../../Actions/MessageActions';
import { CHAT_TYPE_GROUP, MSG_SENT_ACKNOWLEDGE_STATUS_ID } from '../../Helpers/Chat/Constant';
import { formatUserIdToJid, getLocalUserId } from '../../Helpers/Chat/User';
import { getUserIdFromJid } from '../../Helpers/Utility';
import { pollsReceived } from '../../slice/pollSlice';

/**
 * Settles a poll the outbox handed over: keeps the stored poll, gives the local message its
 * poll id and moves it from Pending to Sent. REST answers, so no XMPP acknowledgement follows.
 *
 * @param {object} item Outbox item; params.toJid is the group JID.
 * @param {object} response createPoll answer, data being the poll.
 */
export const markPollSent = (item, response) => (dispatch, getState) => {
    const groupJid = item.params?.toJid || '';
    const groupId = getUserIdFromJid(groupJid);
    const poll = response?.data;
    if (poll) {
        dispatch(pollsReceived([poll]));
        const message = getState().chatConversationHistory?.data?.[groupId]?.messages?.[item.msgId];
        if (message) dispatch(ChatMessageHistoryDataAction({ data: [withPollId(message, poll.pollId)], groupJid }));
    }
    dispatch(
        MessageAction({
            type: 'acknowledge',
            msgType: 'acknowledge',
            msgId: item.msgId,
            fromUserJid: groupJid,
            fromUserId: groupId,
            chatType: CHAT_TYPE_GROUP,
            msgStatus: MSG_SENT_ACKNOWLEDGE_STATUS_ID,
            publisherId: formatUserIdToJid(getLocalUserId()),
            timestamp: Date.now(),
        }),
    );
};

const withPollId = (message, pollId) => ({
    ...message,
    msgBody: { ...message.msgBody, poll: { ...message.msgBody?.poll, pollId } },
});
